export default __webpack_public_path__ + "34c0e36186d7ee5ca367ace80ebea5a0.png";